// CMO Chat - Interface conversationnelle (utilise CxOChatPanel unifié)
import CxOChatPanel from "../direction/CxOChatPanel";

export default function CMOChat() {
  return <CxOChatPanel cxoType="cmo" />;
}
